import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../services/actor.service';
import { AppData } from '../../../../models/appdata';
import { SaveNotesInfoRequest } from '../../../../models/lab/testinfo.model';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'ngbaddnotes',
  templateUrl: './addnotes.modal.html',
  styleUrls: ['./addnotes.modal.scss']
})

export class NgbAddNotesModal implements OnInit {
  @Input() NotesText: string;
  public ShowList: boolean = true; 
  public notesText: string = '';
  
  constructor(
    public activeModal: NgbActiveModal,
    private actorService: ActorService,
    private toastrService: NGXToastrService
  ) { }

  ngOnInit() {
    if (this.NotesText) {
      this.notesText = this.NotesText;
    }
  }
 
  onSubmit() {
    const req = new SaveNotesInfoRequest();
    req.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    req.NotesText = this.notesText;

    this.actorService.SaveNotesInfo(req).subscribe(
      (res) => {
        this.toastrService.ToasterSuccessAlertParam('Notes Saved Successfully!');
        this.activeModal.close(this.notesText);
      },
      (err) => {
        this.toastrService.ToasterSuccessAlertParam('Notes Saved Successfully!');
        this.activeModal.close(this.notesText);
      }
    );
  }

  ModalClose() {
    this.activeModal.dismiss();
  }
}
